import { inject, Service } from '@angular/core';
import { Store } from '@ngrx/store';
import {
    selectProfile,
    selectLoaded,
    selectLoading,
    selectSaving,
    selectSaved,
    selectPasswordSaving,
    selectPasswordSaved,
    selectPasswordError,
} from '../selectors/profile.selector';
import { profileActions } from '../actions/profile.actions';
import { PasswordValue, ProfileValue } from '../models';

@Service()
export class ProfileFacade {
    private readonly store = inject(Store);

    readonly profile = this.store.selectSignal(selectProfile);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly loaded = this.store.selectSignal(selectLoaded);
    readonly saving = this.store.selectSignal(selectSaving);
    readonly saved = this.store.selectSignal(selectSaved);
    readonly passwordSaving = this.store.selectSignal(selectPasswordSaving);
    readonly passwordSaved = this.store.selectSignal(selectPasswordSaved);
    readonly passwordError = this.store.selectSignal(selectPasswordError);

    readonly profile$ = this.store.select(selectProfile);
    readonly loaded$ = this.store.select(selectLoaded);
    readonly loading$ = this.store.select(selectLoading);

    getProfile(): void {
        this.store.dispatch(profileActions.getProfile());
    }

    updateProfile(value: ProfileValue): void {
        this.store.dispatch(profileActions.updateProfile({ value }));
    }

    changePassword(value: PasswordValue): void {
        this.store.dispatch(profileActions.changePassword({ value }));
    }

    clear(): void {
        this.store.dispatch(profileActions.clear());
    }
}
